import { Link } from 'react-router-dom';
import type { Category } from '../../types/models';

interface CategoryTileProps {
  category: Category;
  label: string;
  count?: number;
}

export function CategoryTile({ category, label, count }: CategoryTileProps) {
  return (
    <Link
      to={`/?category=${category}`}
      className="card flex flex-col items-center justify-center gap-2 text-center hover:border-lime-500 transition-colors"
    >
      <div className="text-lime-400 text-2xl font-semibold">{label}</div>
      {typeof count === 'number' && (
        <div className="text-xs text-neutral-400">{count} devices</div>
      )}
    </Link>
  );
}
